import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import './SettingsSheet.css'
import { Link, useNavigate } from "react-router";
import {  setSettingFlag, setCurrentUser } from "../../../../C2wStore/actions";

function SettingsSheet() {
  const navigate = useNavigate(null)
  const settingRef = useRef(null)
  const dispatch = useDispatch()
  const currentUser = useSelector((state) => state?.data?.currentUser);

  const handleLogout = () => {
    localStorage.removeItem('sessionUser');
    dispatch(setCurrentUser(null));
    dispatch(setSettingFlag(false));
    navigate('/');
  };

  /**
 * @hook useEffect - Detect outside clicks to close settings panel
 * @author Vishal Lohbande
 *
 * Description:
 * - Attaches a `mousedown` event listener to the document to detect clicks outside the `settingRef` element.
 * - If a click occurs outside the referenced element, dispatches a Redux action to set the settings flag to false.
 * - Logs `true` to console whenever such an outside click is detected.
 *
 * Behavior:
 * - Uses a ref `settingRef` to check if the clicked target is outside the element.
 * - Cleans up the event listener on component unmount to prevent memory leaks.
 *
 * Usage:
 * - Useful for closing modals, dropdowns, or settings panels when clicking outside.
 */
  useEffect(() => {
    function handleOutsideClick(event) {
      if (settingRef && settingRef.current && !settingRef.current.contains(event.target)) {
        dispatch(setSettingFlag(false))
        console.log(true)
      }
    }
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick)
    }
  }, [])

  return (
    <div
      className="settings">
      <div
        className="settings__right-sheet" ref={settingRef}
      >
        <div className="settings__title">Settings</div>
        <div className="settings__content">
          <div className="settings__terms">
            {/* <Link
            to={'/courses'}
            onClick={() => {
              dispatch(setSettingFlag(false))}}
            >
              Courses
            </Link> */}
          </div>
          <div className="settings__terms">
            <Link
            to={'/about-us'}
            onClick={() => {
              dispatch(setSettingFlag(false))}}
            >
              About Us
            </Link>
          </div>
          <div className="settings__terms">
            <Link
            to={'/enquiry-form'}
            onClick={() => dispatch(setSettingFlag(false))}
            >
              Contact Us
            </Link>
          </div>
          <div className="settings__privacy">
            <Link
              onClick={() => dispatch(setSettingFlag(false))}
            to="/privacypolicy.html" 
            target="_blank" 
            rel="noopener noreferrer"
            >
              Privacy Policy
            </Link>
          </div>
          <div className="settings__terms">
            <Link
              onClick={() => dispatch(setSettingFlag(false))}
           to={'/terms'}
           rel="noopener noreferrer"
            >
              Terms and Conditions
            </Link>
          </div>
          <div className="settings__terms">
            <Link
              onClick={() => {
                console.log(settingRef)
                dispatch(setSettingFlag(false))}}
              to={'/refund'}
              rel="noopener noreferrer"
            >
              Refund Policy
            </Link>
          </div>
      
          <div className="settings__terms">
            {/* <Link
              onClick={() => dispatch(setSettingFlag(false))}
              to={'/login-permission'}
              rel="noopener noreferrer"
            >
            Request Login Permission
            </Link> */}
          </div>

          {currentUser && (
            <div className="settings__terms">
              <Link onClick={handleLogout}>
                Logout
              </Link>
            </div>
          )}

        </div>
      </div>
    </div>

  )
}

export default SettingsSheet
